import { format } from 'date-fns';
import { DateLibOptions, DayPickerProps } from 'react-day-picker';
import { isMobile } from 'react-device-detect';

export const capitalizeFirstLetter = (monthName: string): string => {
  return `${monthName.charAt(0).toUpperCase()}${monthName.slice(1)}`;
};

export const formatCaption = (date: Date, options?: DateLibOptions): string => {
  const monthName = date.toLocaleString(options?.locale?.code, {
    month: 'long',
  });
  const capitalizedMonthName = capitalizeFirstLetter(monthName);

  return `${capitalizedMonthName} ${date.getFullYear()}`;
};

export const formatWeekdayName = (
  weekday: Date,
  options?: DateLibOptions,
): string => {
  return format(weekday, 'ccc', { locale: options?.locale }).replace('.', '');
};

export const getNumberOfMonths = ({
  numberOfMonths,
  mode,
}: Pick<DayPickerProps, 'numberOfMonths' | 'mode'>): number => {
  return numberOfMonths ?? (!isMobile && mode === 'range') ? 2 : 1;
};
